<template>
    <textarea
        ref="textarea"
        class="w-full form-input form-input-bordered py-2"
        rows="2"
        :placeholder="placeholder"
        :value="value"
        :readonly="readonly"
        @change="$emit('input', $event.target.value)"
        @keyup="$emit('input', $event.target.value)"
    ></textarea>
</template>

<script>

  export default {

    components: {},

    props: {
      value: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      initialValueSet: false,
    }),

    watch: {
      value() {
        if (!this.initialValueSet) {
          this.initialValueSet = true;
        }
      },
    },

  };

</script>
